class ProductComponents extends HTMLElement {
  connectedCallback() {
    if (this.dataset.componentsInitialized === 'true') return;

    this.dialog = this.querySelector('[data-components-dialog]');
    this.opener = this.querySelector('[data-components-open]');
    this.closeButton = this.querySelector('[data-components-close]');
    this.swiperContainer = this.querySelector('[data-components-swiper]');

    if (!this.dialog || !this.opener) return;

    this.dataset.componentsInitialized = 'true';
    this.opener.addEventListener('click', () => this.open());
    this.closeButton?.addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('close', () => this.onClose());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
  }

  disconnectedCallback() {
    if (this.dialog?.open) document.documentElement.classList.remove('product-components-is-open');
  }

  open() {
    this.opener.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('product-components-is-open');
    if (!this.dialog.open) this.dialog.showModal();

    window.requestAnimationFrame(() => {
      this.initializeSwiper();
      this.closeButton?.focus({ preventScroll: true });
    });
  }

  onClose() {
    this.opener.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('product-components-is-open');
    this.opener.focus({ preventScroll: true });
  }

  initializeSwiper() {
    if (this.swiper || !this.swiperContainer || typeof window.Swiper !== 'function') return;

    this.swiper = new window.Swiper(this.swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      centeredSlides: true,
      centerInsufficientSlides: true,
      loopFillGroupWithBlank: false,
      slidesPerGroup: 1,
      navigation: {
        nextEl: this.swiperContainer.querySelector('.swiper-button-next'),
        prevEl: this.swiperContainer.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        640: { slidesPerView: 2, centeredSlides: false },
        768: { slidesPerView: 3, centeredSlides: false },
        1024: { slidesPerView: 4, centeredSlides: false }
      }
    });
  }
}

if (!customElements.get('product-components')) {
  customElements.define('product-components', ProductComponents);
}
